import { render, staticRenderFns } from "./NoResultsFound.vue?vue&type=template&id=50bafb57&"
import script from "./NoResultsFound.vue?vue&type=script&lang=ts&"
export * from "./NoResultsFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports